import { Component } from "@angular/core";

@Component({
    selector: "app-statistics",
    templateUrl: "./statistics.component.html",
})
export class StatisticsComponent {}
